import { motion } from "framer-motion";
import { BIO } from "@/data/content";

function Segments({ segs }) {
    return segs.map((seg, i) =>
        seg.url ? (
            <a
                key={i}
                href={seg.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={seg.testid}
                className="u-link font-medium italic text-[#C84B31] transition-colors duration-300 hover:text-[#A83C25]"
            >
                {seg.t}
            </a>
        ) : (
            <span key={i}>{seg.t}</span>
        ),
    );
}

export default function About() {
    return (
        <section id="bio" className="mx-auto max-w-3xl px-6 py-24 sm:px-10 sm:py-32">
            <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#8C8B88]"
            >
                about
            </motion.p>
            <div className="mt-8 space-y-8">
                {BIO.map((segs, i) => (
                    <motion.p
                        key={i}
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                        className="font-serif text-lg leading-[1.75] text-[#141413]/90 sm:text-xl sm:leading-[1.8]"
                    >
                        <Segments segs={segs} />
                    </motion.p>
                ))}
                <motion.div
                    initial={{ opacity: 0, y: 22 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                >
                    <p className="font-serif text-lg italic text-[#141413]/90 sm:text-xl">
                        Thank you for being here,
                    </p>
                    <p className="mt-2 font-serif text-3xl italic text-[#141413] sm:text-4xl">
                        Vinayak
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
